import * as attachmentsApi from '../../api/attachments';
import { handleErrors } from '../ErrorActions';

export function uploadFile(file) {
  return async (dispatch) => {
    try {
      const apiData = await attachmentsApi.uploadAttachment(file);

      if (apiData.hasError) {
        dispatch(handleErrors(apiData.errors, { isTopBanner: apiData.isTopBanner }));
        return;
      }

      return Promise.resolve(apiData.Result);
    } catch (error) {
      dispatch(handleErrors(error));
      return Promise.reject(error);
    }
  };
}
